import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, SparklesIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
const handleComprar = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      content_name: 'Barriga Plana en 21 Días',
      content_ids: ['48331138498810'],
      content_type: 'product',
      value: 24999,
      currency: 'COP'
    });
  }
  window.location.href = 'https://emalia.lat/cart/48331138498810:1';
};
export function PrecioSection() {
  return <section id="precio" className="w-full bg-[#FAF3E0] py-16 md:py-28 px-4" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <motion.div {...fadeInUp} className="text-center" data-id="element-125">
          {/* Price Card */}
          <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl mb-10 md:mb-12" data-id="element-126">
            <div className="inline-flex items-center gap-2 bg-[#A7C4A0]/30 text-[#1B4332] px-4 py-2 rounded-full text-sm font-medium mb-6" data-id="element-127">
              <SparklesIcon className="w-4 h-4" data-id="element-128" />
              Acceso inmediato
            </div>

            <h2 className="md:text-4xl font-bold text-[#1B4332] mb-4 text-[27px]" data-id="element-129">
              Barriga Plana en 21 Días
            </h2>
            <p className="text-[#1B4332]/60 mb-8" data-id="element-130">(sin dejar el arroz)</p>

            <div className="mb-8" data-id="element-131">
              <span className="text-5xl md:text-6xl font-bold text-[#1B4332]" data-id="element-132">
                $24,999
              </span>
              <span className="text-[#1B4332]/60 text-xl ml-2" data-id="element-133">COP</span>
            </div>

            <p className="text-[#1B4332]/70 text-lg mb-8 max-w-md mx-auto" data-id="element-134">
              No estás pagando por "recetas bonitas". Estás pagando por salir
              del modo
              <em data-id="element-135"> "no sé qué hacer con mi cuerpo"</em> y entrar al modo
              <strong data-id="element-136">
                {' '}
                "ya sé exactamente qué me dispara y cómo volver a control".
              </strong>
            </p>

            <motion.button onClick={handleComprar} className="w-full sm:w-auto bg-[#C75B39] text-white text-xl font-bold px-12 py-5 rounded-full 
                         hover:scale-105 transition-transform duration-200 shadow-lg hover:shadow-xl cursor-pointer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} data-id="element-137">
              Comprar ahora →
            </motion.button>

            {/* Guarantee */}
            <div className="mt-8 pt-8 border-t border-[#1B4332]/10" data-id="element-138">
              <div className="flex items-center justify-center gap-3 text-[#1B4332]/70" data-id="element-139">
                <ShieldCheckIcon className="w-5 h-5 text-[#A7C4A0]" data-id="element-140" />
                <span className="text-sm" data-id="element-141">
                  Garantía de 7 días: si no es para ti, pides devolución y
                  listo.
                </span>
              </div>
            </div>
          </div>

          {/* Final CTA */}
          <motion.div {...fadeInUp} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#1B4332] rounded-3xl p-8 md:p-12 text-center" data-id="element-142">
            <h3 className="text-2xl md:text-3xl font-bold text-[#FAF3E0] mb-4" data-id="element-143">
              Hazlo por 21 días.
            </h3>
            <p className="text-[#FAF3E0]/80 text-lg mb-2" data-id="element-144">No por castigo.</p>
            <p className="text-[#A7C4A0] text-xl font-medium mb-8" data-id="element-145">Por paz.</p>
            <p className="text-[#FAF3E0]/70 text-[15px]" data-id="element-146">
              Compra "Barriga Plana en 21 Días (sin dejar el arroz)" y empieza
              hoy con el Día 1.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}